import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, database } from '../firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import { ref, onValue } from 'firebase/database';
import './Login.css';  // Importando o CSS exclusivo para a tela de login

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            const userRef = ref(database, `usuarios/${user.uid}`);
            onValue(userRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    const userType = data.tipo;
                    const redirectPath = location.state?.from?.pathname || (userType === 'admin' ? '/Files' : '/Form');
                    navigate(redirectPath);
                }
            });
        } catch (error) {
            setError('Credenciais incorretas');
        }
    };

    return (
        <div className="login-container"> {/* Adicionando a classe CSS */}
            <h1>Login</h1>
            <form onSubmit={handleLogin}>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    required
                />
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Senha"
                    required
                />
                <button type="submit">Login</button>
                {error && <p>{error}</p>} {/* Exibe o erro, se houver */}
            </form>
        </div>
    );
};

export default Login;
